export const xenvList = [
    'alimp',
    'alipay',
    'bdmp',
    'capp',
    'cowxmp',
    'cxwxmp',
    'driver',
    'drwxmp',
    'esapp',
    'gaswxmp',
    'gjwxmp',
    'h5',
    'kfalimp',
    'kfdriver',
    'kfdwxmp',
    'kfpassenger',
    'kfwxmp',
    'mqq',
    'passenger',
    'qjwxmp',
    'qqmp',
    'thwxmp',
    'weixin',
    'wxmp',
    'yxwxmp',
    'hitchapp',
    'sfcwxmp',
    'hywxmp',
    'hyalimp',
    'hydriver'
];
export const xenvListMini = [
    'alimp',
    'bdmp',
    'cowxmp',
    'cxwxmp',
    'drwxmp',
    'gjwxmp',
    'kfalimp',
    'kfdwxmp',
    'kfwxmp',
    'qqmp',
    'thwxmp',
    'wxmp',
    'yxwxmp',
    'hywxmp',
    'hyalimp'
];
const hongKongHostMap = {
    'api.udache.com': 'api-hk.udache.com',
    'pay.udache.com': 'pay-hk.udache.com',
    'pay.diditaxi.com.cn': 'pay-hk.diditaxi.com.cn',
    'epassport.diditaxi.com.cn': 'epassport-hk.diditaxi.com.cn',
    'common.diditaxi.com.cn': 'common-hk.diditaxi.com.cn',
    'ucenter.diditaxi.com.cn': 'ucenter-hk.diditaxi.com.cn',
    'page.udache.com': 'page-hk.udache.com',
    'page0.udache.com': 'page0-hk.udache.com',
    'page1.udache.com': 'page1-hk.udache.com',
    'page2.udache.com': 'page2-hk.udache.com',
    'page3.udache.com': 'page3-hk.udache.com',
    'page4.udache.com': 'page4-hk.udache.com',
    'page5.udache.com': 'page5-hk.udache.com',
    'page6.udache.com': 'page6-hk.udache.com',
    'page7.udache.com': 'page7-hk.udache.com',
    'page8.udache.com': 'page8-hk.udache.com',
    'page9.udache.com': 'page9-hk.udache.com',
    // 'www.udache.com':	'www-hk.udache.com',
    'winter-campaign.xiaojukeji.com': 'winter-campaign-hk.xiaojukeji.com',
    'v.didi.cn': 'v-hk.didi.cn',
    's.didi.cn': 's-hk.didi.cn',
    'res.xiaojukeji.com': 'res-hk.xiaojukeji.com',
    'passport.didichuxing.com': 'passport-hk.didichuxing.com',
    'help.xiaojukeji.com': 'help-hk.xiaojukeji.com',
    'safe.xiaojukeji.com': 'safe-hk.xiaojukeji.com',
    'bosp-api.xiaojukeji.com': 'bosp-api-hk.xiaojukeji.com',
    'api.didi.cn': 'api-hk.didi.cn'
};
function changeHostToHK(url) {
    let exchangedUrl = url;
    Object.entries(hongKongHostMap).some(([host, hkHost]) => {
        if (new RegExp(host).test(url)) {
            exchangedUrl = url.replace(host, hkHost);
            return true;
        }
        return false;
    });
    return exchangedUrl;
}
export { hongKongHostMap, changeHostToHK };
